var _g, _rect, _g2, _line, _line2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouldingRodWidth01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 212,
    height: 232
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.1921,
    x1: 164.3,
    y1: 36.2,
    x2: 47.5,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "163.2,32.6 169.4,36.2 163.2,39.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "48.6,32.6 42.4,36.2 48.6,39.7  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.9715,
    x1: 169.8,
    y1: 22.8,
    x2: 169.8,
    y2: 38.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.9715,
    x1: 42.2,
    y1: 22.8,
    x2: 42.2,
    y2: 38.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 15.8,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.6316,
    width: 127.5,
    height: 4.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.7,
    y: 14.4,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.566,
    width: 12,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4,
    y: 14.5,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.5586,
    width: 12,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.7,
    y: 12.2,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.3775,
    width: 2.6,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 12.2,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.3775,
    width: 2.6,
    height: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B3B2B2",
    stroke: "#727171",
    strokeWidth: 0.2282,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 187.5,32.7 191,29.1 21.1,29.1 24.4,32.7 187,32.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12.2,
    opacity: 0.7,
    fill: "#C7C6C7",
    stroke: "#727171",
    strokeWidth: 0.2161,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 170,
    height: 16.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouldingRodWidth01);
export default __webpack_public_path__ + "static/media/MouldingRodWidth01.06d5eeaa1cd8b9fc5bc93467f931f297.svg";
export { ForwardRef as ReactComponent };